export function getGenderText(value: any): string {
    switch(value) {
        case 'male':
            return 'Masculino';
        case 'female':
            return 'Feminino';
        default:
            return '';
    }
}